export default [{
  name: 'addRestaurant',
  path: 'addRestaurant',
  component: () => import('./AddRestaurant.vue'),
  meta: {
    title: '餐厅新建'
  }
}]



// WEBPACK FOOTER //
// ./src/router/add_restaurant/index.js